import { CloneButtonProps, useCreatePath, useRecordContext, useResourceContext } from "react-admin"
import Queue from '@mui/icons-material/Queue';

import { ToolbarLinkButton } from "./ToolbarButton";
import { SyntheticEvent } from "react";
import { stringify } from 'query-string';

export const UserCloneButton = (props: CloneButtonProps) => {
    const {
        label = 'Clone',
        scrollToTop = true,
        icon = defaultIcon,
        ...rest
    } = props;
    const resource = useResourceContext(props);
    const record = useRecordContext(props);
    const createPath = useCreatePath();
    const pathname = createPath({ resource, type: 'create' });

    return (
        <ToolbarLinkButton
            to={
                record
                    ? {
                        pathname,
                        search: stringify({
                            source: JSON.stringify(omitId(record)),
                        }),
                    }
                    : pathname
            }
            state={{ _scrollToTop: scrollToTop }}
            label={String(label)}
            onClick={stopPropagation}
            {...sanitizeRestProps(rest)}
        >
            {icon}
        </ToolbarLinkButton>
    )
}

const defaultIcon = <Queue />;

const stopPropagation = (e: SyntheticEvent) => e.stopPropagation();


const omitId = ({ id, ...rest }: any) => rest;

const sanitizeRestProps = ({
    resource,
    record,
    ...rest
}: Omit<CloneButtonProps, 'label' | 'scrollToTop' | 'icon'>) => rest;
